import EstoqueLote from "model/suprimentos/EstoqueLote";

export default class DescarteInutilizavel {

    estoqueLote: EstoqueLote | null;
    quantidadeDescartavel: number | null;

    constructor(
        estoqueLote = null,
        quantidadeDescartavel = 0
    ) {
        this.estoqueLote = estoqueLote;
        this.quantidadeDescartavel = quantidadeDescartavel;
    }
}